// 未来ボードの入口を出すか。ビルド時の設定と、サーバーの状態の両方を見る。
// 本番のクライアントを先に出しても、サーバーで機能が有効になるまで、入口は出ない。
import type { FutureBoardFailure } from "./errors";

// 明示的に "true"（または true）のときだけ有効。未設定は無効。
export function isFutureBoardBuildEnabled(flag: unknown): boolean {
  return flag === true || (typeof flag === "string" && flag.trim().toLowerCase() === "true");
}

// サーバーが「機能は無効」と答えたか（FEATURE_DISABLED）。
export const isServerDisabled = (failure: FutureBoardFailure | null | undefined): boolean => failure?.kind === "disabled";

// 入口（メニュー・ホームの案内）を出すか。サーバーの状態が分かっていない間は、設定に従う。
export function shouldShowEntry(buildFlag: unknown, serverFailure?: FutureBoardFailure | null): boolean {
  return isFutureBoardBuildEnabled(buildFlag) && !isServerDisabled(serverFailure);
}
